import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useSelector } from 'react-redux';

import configurations from '@/config';
import { getAccessToken } from '@/utils/api';

import { usePreferences } from '../usePreferences';

interface FetchPromptsRequest {
  currentPracticeId: string;
  currentOrganizationId: string;
}

export interface PromptOption {
  name: string;
  ui_label: string;
}

const fetchPrompts = async ({
  currentPracticeId,
  currentOrganizationId,
}: FetchPromptsRequest): Promise<Array<PromptOption>> => {
  const { data } = await axios.get<Array<PromptOption>>(
    `${configurations.API_URL}/videa-notes/prompts`,
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        practice: currentPracticeId,
        org: currentOrganizationId,
      },
    },
  );
  return data;
};

export const usePrompts = () => {
  // prompts are gated by a feature flag
  const { data: preferences } = usePreferences();
  const isVideaNotesEnabled = preferences?.isVideaNotesEnabled;

  const {
    primaryPracticeId: currentPracticeId,
    primaryOrganizationId: currentOrganizationId,
  } = useSelector((state: any) => state.login.user);

  return useQuery({
    queryKey: ['videa-notes-prompts', currentPracticeId, currentOrganizationId],
    queryFn: () => {
      return fetchPrompts({ currentPracticeId, currentOrganizationId });
    },
    enabled:
      currentPracticeId !== undefined &&
      currentOrganizationId !== undefined &&
      isVideaNotesEnabled === true,
  });
};
